import React from "react";
import { useSelector } from "react-redux";
import { ClipboardList, History, PanelLeft, Sparkles, X } from "lucide-react";
import "./chartframe.css";
import { chartTabAllowed } from "../../../config/practice";

// Chart top bar: sidebar toggle, the chart tabs (CareIQ first), and the
// Orders / Timeline / close actions on the right.
export const NavFrame = ({
  onTabClick,
  hasRpmAccess,
  activeTab,
  onToggleSidebar,
  sidebarCollapsed,
  showTimeline,
  onToggleTimeline,
  onOrders,
  onClose,
}) => {
  const homescreen = useSelector(state => state.userPrivileges.homescreen);
  // Tabs keep their ids (renderContent in patientchartwrap switches on them).
  // Summary (id 0) is intentionally not listed - CareIQ replaces it as the
  // chart's landing view; case 0 stays in patientchartwrap so anything that
  // still routes to it keeps rendering.
  const allTabs = [
    { id: 11, label: "CareIQ", icon: <Sparkles /> },
    { id: 10, label: "Non-visit notes", requiresHomescreen: "Threads" },
    { id: 1, label: "Labs" },
    { id: 2, label: "Documents" },
    { id: 3, label: "Vitals" },
    { id: 4, label: "RPM", requires: true },
    { id: 5, label: "Prior visits" },
    // { id: 6, label: "Imaging" },
    // Re-enabled 2026-09-02: the questionnaire fill flow (bangquestions
    // migration) lives here alongside the completed-forms history.
    { id: 7, label: "Forms" },
    { id: 8, label: "CCM" },
    { id: 9, label: "Medications" },
  ];

  const tabs = allTabs.filter((tab) => {
    // The practice's chart tab allowlist (7825: Vitals only; 9928: all).
    if (!chartTabAllowed(tab.id)) return false;
    // RPM condition
    if (tab.requires && !hasRpmAccess) return false;
    // Homescreen privilege condition
    if (tab.requiresHomescreen && !homescreen.includes(tab.requiresHomescreen)) return false;
    return true;
  });

  return (
    <div className="bmch bmch-bar">
      {onToggleSidebar && (
        <button
          type="button"
          className="bmch-collapse"
          onClick={onToggleSidebar}
          title={sidebarCollapsed ? "Show patient panel" : "Hide patient panel"}
          aria-label={sidebarCollapsed ? "Show patient panel" : "Hide patient panel"}
        >
          <PanelLeft />
        </button>
      )}
      <div className="bmch-tabs" role="tablist">
        {tabs.map((tab) => (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            key={tab.id}
            className={`bmch-tab${activeTab === tab.id ? " on" : ""}`}
            onClick={() => onTabClick(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
      <div className="bmch-bar-actions">
        {onOrders && (
          <button type="button" className="bmch-bar-btn" onClick={onOrders}>
            <ClipboardList />
            Orders
          </button>
        )}
        {onToggleTimeline && activeTab === 11 && (
          <button
            type="button"
            className={`bmch-bar-btn${showTimeline ? " on" : ""}`}
            onClick={onToggleTimeline}
            aria-pressed={showTimeline}
          >
            <History />
            Timeline
          </button>
        )}
        {onClose && (
          <button type="button" className="bmch-bar-btn icon" onClick={onClose} title="Close chart" aria-label="Close chart">
            <X />
          </button>
        )}
      </div>
    </div>
  );
};
